<template>
  <svg
    width="96"
    height="95"
    viewBox="0 0 96 95"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_11857_61489)">
      <ellipse
        cx="47.8386"
        cy="47.4649"
        rx="47.3386"
        ry="47.4649"
        fill="#F5F5F5"
      />
      <mask
        id="mask0_11857_61489"
        style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="96"
        height="95"
      >
        <ellipse
          cx="47.8386"
          cy="47.4649"
          rx="47.3386"
          ry="47.4649"
          fill="#F5F5F5"
        />
      </mask>
      <g mask="url(#mask0_11857_61489)">
        <path
          opacity="0.5"
          d="M67 94.9097L17.5 67.9097L52.5 18.9097L164 94.9097H67Z"
          fill="#E6E6E6"
        />
      </g>
      <path
        d="M78.2129 59.1135L54.9436 21.1988C51.7001 15.9643 44.0847 15.9643 40.841 21.1988L17.5717 59.1135C14.187 64.631 18.1358 71.8461 24.6229 71.8461H71.1615C77.6488 71.8461 81.5976 64.7724 78.2129 59.1135Z"
        fill="#F6B72D"
      />
      <path
        d="M24.636 67.1895C22.5306 67.1895 21.4078 65.7686 21.127 65.0582C20.8463 64.3479 20.1444 62.7849 21.2674 60.9379L44.2864 22.8602C45.4092 21.0131 47.0935 20.8711 47.7954 20.8711C48.4972 20.8711 50.1815 21.0132 51.3044 22.8602L74.4638 60.9379C75.5866 62.785 74.8849 64.49 74.6042 65.0582C74.3235 65.6266 73.2006 67.1895 71.0952 67.1895H24.636Z"
        fill="black"
        fill-opacity="0.08"
      />
      <path d="M24.9697 63.0556L47.8387 25.9092L70.7075 63.0556H24.9697Z" fill="#F6B72D"/>
      <path d="M47.8013 52.7564C47.2401 52.7564 46.679 52.3325 46.5387 51.7671L44.4343 38.6241C44.1538 36.6456 45.697 34.667 47.8013 34.667C49.9057 34.667 51.4489 36.5042 51.1683 38.6241L49.0639 51.7671C48.9236 52.3325 48.3624 52.7564 47.8013 52.7564Z" fill="black"/>
      <path d="M47.8014 59.3984C49.351 59.3984 50.6072 58.133 50.6072 56.572C50.6072 55.011 49.351 53.7456 47.8014 53.7456C46.2518 53.7456 44.9956 55.011 44.9956 56.572C44.9956 58.133 46.2518 59.3984 47.8014 59.3984Z" fill="black"/>
    </g>
    <defs>
      <clipPath id="clip0_11857_61489">
        <rect
          width="95"
          height="95"
          fill="white"
          transform="translate(0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
  export default {
    name: 'WarningIllustration',
  };
</script>
